// This file is generated by pnpm icons:generate. Do not edit.

import {BubbleInfo_Stroke2_Corner2_Rounded as CanonicalBubbleInfo_Stroke2_Corner2_Rounded} from './Bubble'

/** @deprecated Import BubbleInfo_Stroke2_Corner2_Rounded from `#/components/icons/Bubble` instead. */
export const BubbleInfo_Stroke2_Corner2_Rounded =
  CanonicalBubbleInfo_Stroke2_Corner2_Rounded
